import create from 'zustand'
import { deleteManuallyUploadedImage, fetchRegisteredImages } from '../api'

export const useRegisteredImagesStore = create((set, get) => ({
	registeredImages: [],
	selectedRegistrationCertificate: null,
	totalRegisteredImagesCount: 0,
	pageNumber: 0,
	hasRegisteredImagesInitiallyLoaded: false,
	searchString: '',
	uploadImagesModalOpen: false,
	setUploadImagesModalOpen: (uploadImagesModalOpen) => {
		set({
			uploadImagesModalOpen,
		})
	},

	setSearchString: (searchString) => set({ searchString }),

	fetchRegisteredImages: async (registrationCertificateId, params) => {
		const { pageNumber, registeredImages, searchString } = get()

		const currentPage = params && params.isInitialLoad ? 0 : pageNumber
		const perPage = 50

		let registeredImagesResponse
		try {
			registeredImagesResponse = await fetchRegisteredImages({
				registrationCertificateId,
				page: currentPage,
				perPage,
				...(searchString ? { filters: { partnerImageId: searchString } } : {}),
			})
		} catch (error) {
			set({
				registeredImages: [],
				totalRegisteredImagesCount: 0,
				pageNumber: 0,
				searchString: '',
				uploadImagesModalOpen: false,
				selectedRegistrationCertificate: null,
			})

			return
		}

		if (
			!registeredImagesResponse.registrationCertificate ||
			!registeredImagesResponse.registeredImageData
		) {
			set({
				registeredImages: [],
				totalRegisteredImagesCount: 0,
				pageNumber: 0,
				searchString: '',
				uploadImagesModalOpen: false,
				selectedRegistrationCertificate: null,
			})
			return registeredImagesResponse
		}

		const { registrationCertificate, registeredImageData } =
			registeredImagesResponse
		const { data, pagination } = registeredImageData

		const newImages =
			params && params.isInitialLoad ? data : [...registeredImages, ...data]

		set({
			registeredImages: newImages,
			totalRegisteredImagesCount: pagination.totalItems,
			pageNumber: currentPage + 1,
			hasRegisteredImagesInitiallyLoaded: true,
			uploadImagesModalOpen: false,
			selectedRegistrationCertificate: registrationCertificate,
		})

		return registeredImagesResponse
	},
	deleteImageId: async ({ registeredImageId, registrationCertificateId }) => {
		const { registeredImages, totalRegisteredImagesCount } = get()

		const response = await deleteManuallyUploadedImage({
			registeredImageId,
			registrationCertificateId,
		})

		const newImages = registeredImages.filter(
			(image) => image.registered_image_id !== registeredImageId,
		)
		const newTotalCount = totalRegisteredImagesCount - 1

		set({
			registeredImages: newImages,
			totalRegisteredImagesCount: newTotalCount,
		})

		return response
	},
}))
